import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { Currency } from '/@/modules/predefined/models/Currency';
import { PredefinedCountry } from '/@/modules/predefined/enums/PredefinedCountry';
import { Announcement } from '@/modules/announcement/models/Announcement';

export class Country extends BaseEntityModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {string}
   */
  code;

  /**
   * @var {boolean}
   */
  active;

  /**
   * @var {array<Jurisdiction>}
   */
  jurisdictions;

  /**
   * @var {string}
   */
  currencyId;

  /**
   * @var {Currency}
   */
  currency;

  /**
   * @var {Date}
   */
  deletedAt;

  constructor(model = {}) {
    super(model);

    this.id = model.id;
    this.name = model.name;
    this.code = model.code;
    this.active = model.active;
    this.jurisdictions = model.jurisdictions;
    this.currencyId = model.currencyId;
    this.currency = Currency.mapModelOrNull(model.currency);

    this.announcements = Announcement.mapModels(model.announcements);
  }

  /**
   * @returns {?boolean}
   */
  get isCanadaOrUnitedStates() {
    return (
      this.id === PredefinedCountry.CANADA.id || this.id === PredefinedCountry.UNITED_STATES.id
    );
  }
}
